import React from 'react';

import UnlockIcon from '../icons/UnlockIcon'
import auth from '../../services/auth';
import GA from '../../services/ga';

const TRIAL_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

const getTrialLabels = (user) => {
  if (!user || auth.isProMembership()) return null;

  const createdAt = new Date(user.createdOn).getTime();
  if (!Number.isFinite(createdAt)) return null;

  const remainingMs = createdAt + TRIAL_DAYS * DAY_MS - Date.now();
  if (remainingMs <= 0) return null;

  if (remainingMs > DAY_MS) {
    const remainingDays = Math.ceil(remainingMs / DAY_MS);

    return {
      desktop: `${remainingDays} Trial Days Left`,
      mobile: `${remainingDays} Days Left`,
    };
  }

  return {
    desktop: 'Trial Ends Today',
    mobile: 'Ends Today',
  };
};

function UnlockButton(props){
  const trialLabels = props.showTrialCountdown ? getTrialLabels(props.user || auth.getUser()) : null;
  const buttonClassName = [
    'inline-flex',
    'max-w-full',
    'items-center',
    'justify-center',
    'gap-2',
    'rounded-full',
    'bg-green-700',
    'px-3',
    'py-2',
    'text-xs',
    'font-bold',
    'leading-tight',
    'text-white',
    'shadow-sm',
    'transition-colors',
    'duration-150',
    'hover:bg-green-800',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-green-400',
    'focus:ring-offset-1',
    'active:bg-green-900',
    props.className,
  ].filter(Boolean).join(' ');

  return (
    <>
      <button
        type="button"
        className={buttonClassName}
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          }

          if (props.showTrialCountdown) {
            GA.track({
              category: 'Trial',
              action: 'trial_countdown_unlock_clicked',
            });
          }

          auth.showUnlockDialog()
        }}
      >
        <span className="inline-flex flex-shrink-0 items-center">
          <UnlockIcon size={18} />
        </span>

        <span className="min-w-0 truncate">
          {trialLabels &&
            <>
              <span className="hide-small whitespace-nowrap">{trialLabels.desktop}</span>
              <span className="hide-large whitespace-nowrap">{trialLabels.mobile}</span>
            </>
          }
          {!trialLabels && props.text &&
            <span className="whitespace-nowrap">{props.text}</span>
          }
          {!trialLabels && !props.text &&
            <>
              <span className="hide-small whitespace-nowrap">Unlock PRO Access</span>
              <span className="hide-large whitespace-nowrap">Unlock</span>
            </>
          }
        </span>
      </button>
    </>
  );
};

UnlockButton.defaultProps = {
  qaCount: 3869,
  text: null,
  onClick: null,
  showTrialCountdown: false,
  user: null,
  className: null
};

export default UnlockButton;
